import r from "./index820.js";
var a = r.Uint8Array;
export {
  a as default
};
